import { BUCKET_URL } from "@shared/config";

/**
 * Constrói a URL completa de um asset armazenado no bucket S3/CDN.
 *
 * @param path - Caminho ou token do arquivo no bucket (ex: "logos/client.png")
 * @returns URL completa do asset. Retorna `BUCKET_URL` sem barra final se `path` for falsy.
 *
 * @example
 * buildAssetUrl("logos/client.png")
 * // → "https://bucket.example.com/logos/client.png"
 *
 * buildAssetUrl("/logos/client.png")
 * // → "https://bucket.example.com/logos/client.png"  (barra dupla normalizada)
 */
export function buildAssetUrl(path: string): string {
  if (!path) return BUCKET_URL;
  return [BUCKET_URL, path].join("/").replace(/([^:]\/)\/+/g, "$1");
}
